import * as React from 'react';
import { Box, Typography } from '@material-ui/core';

export interface DamageReferentialLabelProps {
  displayName?: string | null;
  displayDescription?: string | null;
  level?: number | null;
}

const levelColors: Record<number, string> = { 1: '#E8B92E', 2: '#FF7345', 3: '#C73838' };

const SeverityBars: React.FC<{ level: number }> = ({ level }) => (
  <Box
    display="flex"
    alignItems="flex-end"
    justifyContent="center"
    flexShrink={0}
    width={36}
    height={36}
    borderRadius={8}
    bgcolor="grey.100"
    style={{ gap: 3, paddingBottom: 9, boxSizing: 'border-box' }}
  >
    {[1, 2, 3].map((bar) => (
      <Box
        key={bar}
        width={4}
        height={6 + bar * 5}
        borderRadius={2}
        bgcolor={bar <= level ? levelColors[Math.min(level, 3)] : 'grey.300'}
      />
    ))}
  </Box>
);

const DamageReferentialLabel: React.FC<DamageReferentialLabelProps> = ({ displayName, displayDescription, level }) => (
  <Box display="flex" alignItems="center" py={0.5} style={{ gap: 12 }}>
    {level ? <SeverityBars level={level} /> : null}
    <Box display="flex" flexDirection="column" style={{ gap: 2 }}>
      <Typography variant="body2" style={{ fontWeight: 600 }}>
        {displayName}
      </Typography>
      {displayDescription ? (
        <Typography variant="caption" color="textSecondary">
          {displayDescription}
        </Typography>
      ) : null}
    </Box>
  </Box>
);

export default DamageReferentialLabel;
